import * as React from "react";
import { Platform, PlatformContext } from "../components/context/platform";

interface DefaultNeeded<T> {
    default: T,
    latino?: T,
    supreme?: T,
    create?: T
}
interface AllGiven<T> {
    latino: T,
    supreme: T,
    create: T
}
type PlatformSelect<T> = AllGiven<T> | DefaultNeeded<T>
export function sp<T>(ctx: Platform, select: PlatformSelect<T>): T {
    if (Object.keys(select).includes(ctx)) {
        return select[ctx]!
    }
    return select[ctx] || (select as DefaultNeeded<T>).default
}

export const PlatformRenderer: React.FC<{ only: Platform | Platform[], children: React.ReactElement }> = ({ only, children }) => {
    const platform = React.useContext(PlatformContext)
    if ((Array.isArray(only) && only.includes(platform)) || only == platform) {
        return children
    }
    return null
}


// WEBPACK FOOTER //
// ./src/utils/platformSelect.tsx